import PropTypes from 'prop-types';
import React__default from 'react';
import { ListboxPopover } from '../listbox/listbox-popover.component.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { className } from '../../../core/utilities/classnames.utils.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const propTypes = {
    /**
   * Set to "true" if the Combobox is rendering inside a Modal.
   */ inModal: PropTypes.bool
};
/**
 * @subcomponent Combobox
 */ const ComboboxPopover = renderWithRef('ComboboxPopover', propTypes, (props, ref)=>{
    const { children, placement = 'bottom start', offset = 2, inModal, className: className$1 } = props;
    const classes = className(className$1, 'swan-combobox-popover', inModal ? 'swan-legacy-combobox-popover-in-modal' : null);
    return /*#__PURE__*/ React__default.createElement(ListboxPopover, _object_spread_props(_object_spread({
        className: classes
    }, props), {
        isNonModal: true,
        placement: placement,
        offset: offset,
        ref: ref
    }), children);
});

export { ComboboxPopover };
